var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-tabs-wrapper-content"},[_c('log-list-table',{attrs:{"filterSubject":_vm.nuveiCard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }